import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import theme from "../../utils/theme";

export const CustomTabs = styled((props) => <Tabs {...props} />)({
  // borderWidth: "1px",
  // borderColor: theme.palette.grey[300],
  // borderStyle: "solid",
  marginTop: theme.spacing(2),
  borderRadius: 8,
});

export const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    color: "#000",
  })
);

export const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index ? children : null}
    </div>
  );
};
